
export function openUserFormModal (orgUserId, showModal) {
  import('./EmployeeFormModal.vue')
    .then(async module => {
      const EmployeeFormModal = module.default
      await showModal({
        component: EmployeeFormModal,
        props: {
          itemId: orgUserId
        }
      })
    })
}
